<app-navigation-list [mode]="'mobile'" [navTree]="navTree"></app-navigation-list>
